import { render } from "./HandleViewHeader.vue?vue&type=template&id=da9ae738&scoped=true"
import script from "./HandleViewHeader.vue?vue&type=script&lang=js"
export * from "./HandleViewHeader.vue?vue&type=script&lang=js"

import "./HandleViewHeader.vue?vue&type=style&index=0&id=da9ae738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9ae738"]])

export default __exports__